var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklistIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20.252,
    viewBox: "0 0 24 20.252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "list-check-solid_1_",
    "data-name": "list-check-solid (1)",
    d: "M7.081,32.211A1.122,1.122,0,0,1,7.166,33.8l-3.375,3.75a1.106,1.106,0,0,1-.806.37,1.15,1.15,0,0,1-.825-.328L.28,35.717a1.134,1.134,0,0,1,0-1.594,1.12,1.12,0,0,1,1.589,0l1.036,1.036,2.583-2.868a1.122,1.122,0,0,1,1.589-.084Zm0,7.5A1.122,1.122,0,0,1,7.166,41.3l-3.375,3.75a1.106,1.106,0,0,1-.806.37,1.15,1.15,0,0,1-.825-.328L.28,43.216a1.124,1.124,0,0,1,1.589-1.589l1.036,1.036,2.583-2.868a1.122,1.122,0,0,1,1.589-.084Zm3.37-4.79a1.5,1.5,0,0,1,1.5-1.5h10.5a1.5,1.5,0,1,1,0,3h-10.5A1.5,1.5,0,0,1,10.451,34.92Zm0,7.5a1.5,1.5,0,0,1,1.5-1.5h10.5a1.5,1.5,0,1,1,0,3h-10.5A1.5,1.5,0,0,1,10.451,42.419Zm-3,7.5a1.5,1.5,0,0,1,1.5-1.5h13.5a1.5,1.5,0,1,1,0,3H8.951A1.5,1.5,0,0,1,7.452,49.918ZM2.2,47.669a2.25,2.25,0,1,1-2.25,2.25,2.25,2.25,0,0,1,2.25-2.25Z",
    transform: "translate(0.05 -31.916)",
    fill: "#21827f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistIcon);
export default __webpack_public_path__ + "static/media/checklist-icon.ce18a58a565833895d1792a0094aa0e5.svg";
export { ForwardRef as ReactComponent };